'use client'

import {
  BatteryChargingFullOutlined,
  ElectricalServicesOutlined,
  HandshakeOutlined,
  SellOutlined
} from '@mui/icons-material'
import type { ReactElement } from 'react'

import { categoryIcons } from '~/components/QuickSearch/icons'

import type { AssistantMentionCategory } from './useAssistantMentions'

const assistantCategoryIcons: Record<AssistantMentionCategory, ReactElement> = {
  ...categoryIcons,
  battery: <BatteryChargingFullOutlined fontSize="small" />,
  generator: <ElectricalServicesOutlined fontSize="small" />,
  product: <SellOutlined fontSize="small" />,
  agreement: <HandshakeOutlined fontSize="small" />
}

export default assistantCategoryIcons
